export default __webpack_public_path__ + "static/media/buzzer - inactive.872b79d8.svg";